// La landing es pública: sin el interceptor de comandoApi, que manda al login.
import axios from 'axios';

const api = axios.create({ baseURL: '/api/refugios/' });

export async function obtenerSitio() {
  const { data } = await api.get('sitio/');
  return data;
}

export async function listarProyectos({ region = null, destacados = false } = {}) {
  const params = {};
  if (region) params.region = region;
  if (destacados) params.destacados = 1;
  const { data } = await api.get('proyectos/', { params });
  return data;
}

export async function obtenerProyecto(id) {
  const { data } = await api.get(`proyectos/${id}/`);
  return data;
}

export async function enviarContacto(datos) {
  const { data } = await api.post('contacto/', datos);
  return data;
}
